import React from 'react';
import PropTypes from 'prop-types';

import {concatUrl} from '../helpers/url';
import {getCall} from '../helpers/request';
import GlobalContext from '../helpers/context';


class DatabaseStatus extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            applicationActive: true
        };

        this.delay = 60000;
        this.db_status_url = concatUrl(window.ROOT_URL, 'database_status');
    }

    componentDidMount(){
        window.setInterval(function(){
            this.checkStatus();
        }.bind(this), this.delay);
    }

    checkStatusFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not receive database status info.');
    };

    checkStatusDone = (data) => {
        if(data.applicationActive !== this.state.applicationActive) {
            if (!data.applicationActive) {
                this.setState({applicationActive: false});
                this.context.applicationMode(false);
            } else {
                this.setState({applicationActive: true});
                this.context.applicationMode(true);
            }
        }
    };

    checkStatus = () => {
        getCall(this.db_status_url, this.checkStatusDone, this.checkStatusFailed);
    };

    render() {
        return (
            <span></span>
        );
    }

}

DatabaseStatus.contextType = GlobalContext;

DatabaseStatus.propTypes = {
    callBack: PropTypes.func
};

export default DatabaseStatus;
